import { useEffect, useState } from 'react';
import { Dropdown } from 'rsuite';
import { useAppDispatch, useAppSelector } from '../store/hook';
import { selectCurrentLocale, updateLocale } from '../store/authSlice';
import * as locales from 'rsuite/locales';
import {
  getDomainFromUrl,
  getNavigatorLanguage,
  localeToNavigatorLanguage,
  validLocaleList
} from '../utils';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { getLocalLanguage } from '../services';
interface IProps {
  host: string;
  renderToggle: any;
}
export const HomeLocaleSelector = ({ host, renderToggle }: IProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const userLocale = getLocalLanguage();
  const currentLocale: string = useAppSelector(selectCurrentLocale);
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [localeKey, setLocaleKey] = useState<string>(userLocale);
  const [cookies, setCookie] = useCookies(['locale']);
  const languages: Record<string, any> = locales || {};
  const onChange = (key: string): void => {
    const locale = key === 'auto' ? getNavigatorLanguage() : key;
    setLocaleKey(key);
    dispatch(updateLocale({ key: key, locale: locale }));
  };
  useEffect(() => {
    const domain = getDomainFromUrl(host);
    if (domain) {
      setCookie('locale', localeToNavigatorLanguage(currentLocale), {
        sameSite: 'none',
        secure: true,
        path: '/',
        domain: domain
      });
    }
  }, [currentLocale]);
  useEffect(() => {
    const textList: Record<string, string> = {
      auto: t('common.localeAutoDetect'),
      enUS: 'English',
      zhCN: '简体中文',
      zhTW: '繁体中文',
      jaJP: '日本語',
      frFR: 'Français',
      esES: 'Español',
      koKR: '한국인'
    };
    const res = ['auto', ...Object.keys(locales)]
      .filter((key) => validLocaleList.includes(key))
      .map((key) => ({
        key,
        value: languages[key],
        text: textList[key]
      }));
    setData(res);
  }, [locales, t]);
  return (
    <>
      <Dropdown
        className="land-dropdown"
        trigger="hover"
        placement="bottomEnd"
        activeKey={localeKey}
        renderToggle={renderToggle}
      >
        {data.map((obj: Record<string, any>, index: number) => {
          return (
            <Dropdown.Item
              eventKey={obj.key}
              key={index + 1}
              onSelect={(eventKey: string) => {
                onChange(eventKey);
              }}
            >
              {obj?.text}
            </Dropdown.Item>
          );
        })}
      </Dropdown>
    </>
  );
};
